import {
  get_start30tbw38mnjak0 as get_start,
  get_endInclusive2wh7ub8763o5h as get_endInclusive,
  get_start1ib7kl469eh9c as get_start_0,
  get_endInclusive3dsvnewm08bor as get_endInclusive_0,
} from './ModelFields-372156621.mjs';
import {
  lte2qmhlnwrclg8p as lte,
  eq353yrgcpovoi1 as eq,
  gte1zw995v5ulf70 as gte,
} from '../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { get_notNull2od35hy6ssmdh as get_notNull } from '../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  or1uh2qn0k1rz6c as or,
  and3dbt2f202um49 as and,
} from '../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function overlaps(_this__u8e3s4, other) {
  return and(lte(get_start(_this__u8e3s4), other.endInclusive_1), or(eq(get_endInclusive(_this__u8e3s4), null), gte(get_notNull(get_endInclusive(_this__u8e3s4)), other.start_1)));
}
function inside(_this__u8e3s4, other) {
  return and(gte(_this__u8e3s4, other.get_start_iypx6h_k$()), lte(_this__u8e3s4, other.get_endInclusive_r07xpi_k$()));
}
function overlaps_0(_this__u8e3s4, other) {
  return and(lte(get_start_0(_this__u8e3s4), other.endInclusive_1), gte(get_endInclusive_0(_this__u8e3s4), other.start_1));
}
function contains(_this__u8e3s4, date) {
  return and(lte(get_start_0(_this__u8e3s4), date), gte(get_endInclusive_0(_this__u8e3s4), date));
}
//region block: exports
export {
  contains as contains5fsvztcdjo1e,
  inside as insideoec66sredh4u,
  overlaps as overlaps2e3dna24gi3hb,
  overlaps_0 as overlapsia57gal7znoc,
};
//endregion

//# sourceMappingURL=dateRangeConditions.mjs.map
